import axios, {AxiosRequestConfig} from "axios";
import {ILogin} from "../models/auth.model";
import localStorageKeys from "../constants/localStorageKeys.enum";
import qs from "qs";

export const setToken: (token: ILogin) => void = (token) => {
  const newToken = JSON.stringify({
    access_token: token.access_token,
    expire: token.expires_in,
    refresh_token: token.refresh_token,
    expires_in: token.expires_in,
    scope: token.scope,
    nationalId: token.nationalId,
    birthDate: token.birthDate,
    mobileNumber: token.mobileNumber,
    firstName: token.firstName,
    lastName: token.lastName,
    gender: token.gender
  });
  localStorage.setItem(localStorageKeys.tokenInfo, newToken);
}

export const getToken: () => ILogin = () => {
  const token = localStorage.getItem(localStorageKeys.tokenInfo);
  const tokenObj = JSON.parse(token!);
  return tokenObj;
}

export const removeToken: () => void = () => {
  localStorage.removeItem(localStorageKeys.tokenInfo);
};

let axiosRequestConfig: AxiosRequestConfig = {
  headers: {
    Accept: "application/json;utf-8",
  },
};

export const setRequestConfig: (config: AxiosRequestConfig) => AxiosRequestConfig = (config) => {
  let newHeader = config.headers;
  if (newHeader) {
    newHeader = {
      ...axiosRequestConfig.headers,
      ...config.headers,
    };
  }

  axiosRequestConfig = {...axiosRequestConfig, ...config};

  return {...axiosRequestConfig, ...config};
};


let persianNumbers = [/۰/g, /۱/g, /۲/g, /۳/g, /۴/g, /۵/g, /۶/g, /۷/g, /۸/g, /۹/g],
  arabicNumbers = [/٠/g, /١/g, /٢/g, /٣/g, /٤/g, /٥/g, /٦/g, /٧/g, /٨/g, /٩/g];
export const fixNumbers = (str: any) => {
  if (typeof str === "string") {
    for (let i = 0; i < 10; i++) {
      str = str.replace(persianNumbers[i], i).replace(arabicNumbers[i], i);
    }
  }
  return str;
};

export const isValidURL = (str: any) => {
  const pattern = new RegExp('^(https?:\\/\\/)?' + // protocol
    '((([a-z\\d]([a-z\\d-]*[a-z\\d])*)\\.)+[a-z]{2,}|' + // domain name
    '((\\d{1,3}\\.){3}\\d{1,3}))' + // OR ip (v4) address
    '(\\:\\d+)?(\\/[-a-z\\d%_.~+]*)*' + // port and path
    '(\\?[;&a-z\\d%_.~+=-]*)?' + // query string
    '(\\#[-a-z\\d_]*)?$', 'i'); // fragment locator
  return pattern.test(str);
}

// Function that will be called to refresh authorization
export const refreshAuthLogic = (failedRequest: any) => {
  let getUserLoginInfo = JSON.parse(localStorage.getItem("userLoginInfo") as any) as any;
  // console.log(getUserLoginInfo);
  return axios
    .post(
      `${process.env.REACT_APP_BASE_URL_FS}/oauth/token`,
      qs.stringify({
        grant_type: "refresh_token",
        refresh_token: getUserLoginInfo["refresh_token"],
        scope: getUserLoginInfo["scope"],
      }),
      {
        headers: {
          "content-type": "application/x-www-form-urlencoded;charset=utf-8",
        },
        auth: {
          username: `${process.env.REACT_APP_CLIENT_ID}`,
          password: `${process.env.REACT_APP_CLIENT_SECRET}`,
        },
      }
    )
    .then((tokenRefreshResponse) => {
      // console.log(tokenRefreshResponse);
      localStorage.setItem(
        "userLoginInfo",
        JSON.stringify({
          ...tokenRefreshResponse.data,
          nationalId: getUserLoginInfo.nationalId,
          birthDate: getUserLoginInfo.birthDate,
          mobileNumber: getUserLoginInfo.mobileNumber,
        })
      );
      failedRequest.response.config.headers[
        "Authorization"
        ] = `Bearer ${tokenRefreshResponse.data["access_token"]}`;
      return Promise.resolve();
    });
};

export const generateKey = (pre: any) => {
  return `${pre}_${Math.random() * 1000}`;
};

export function capitalizeFirstLetter(str: string): string {
  return str.charAt(0).toUpperCase() + str.slice(1);
}

export function formatBirthDate(birthDate: string): string {
  return birthDate.slice(0, 4) + "/" + birthDate.slice(4, 6) + "/" + birthDate.slice(6);
}

export const logOut = () => {
  try {
    localStorage.removeItem("userLoginInfo");
  } catch (e: any) {
    // console.log(e);
    window.location.href = "/";
  } finally {
    window.location.href = "/";
  }
};

export const toPersianDigit = (str: any) => {
  const id = ['۰', '۱', '۲', '۳', '۴', '۵', '۶', '۷', '۸', '۹'];
  return str.replace(/[0-9]/g, (w: any) => id[+w]);
}
